export const NUM_ONBOARDING_STEPS = 3;
export const TRIANGLE_AUTOFILL_TIMING = 500;
export const DASHBOARD_ONBOARDING_STEPS = 4;
export const LEARNER_ONBOARDING_STEPS = 7;
export const PARENT_ONBOARDING_STEPS = 6;
